module.exports = {"button":"Zamknij","rodoStart":"Potwierdzam, że zapoznałem/am się z","rodoEnd":"klauzulą informacyjną Sagiton Sp. z o.o.","dataStart":"Zgoda na","dataEnd":"przetwarzanie danych w celu kontaktu","marketingEnd":"przetwarzanie danych w celach marketingowych"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/pl/consent/common.json
// module id = 166
// module chunks = 0